module.exports = __webpack_public_path__ + "static/media/logo.c93c8210.svg";